import React from "react";

const THRESHOLD = 60;

const PullIndicator = ({ pullDistance, refreshing }) => {
  if (!refreshing && pullDistance <= 0) return null;

  const ready = pullDistance >= THRESHOLD;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: refreshing ? 48 : pullDistance,
        overflow: "hidden",
        transition: refreshing ? "height 0.2s ease" : "none",
      }}
    >
      <div
        style={{
          width: 24,
          height: 24,
          border: "2.5px solid var(--color-accent-primary)",
          borderTopColor: ready || refreshing ? "var(--color-accent-primary)" : "transparent",
          borderRadius: "50%",
          animation: refreshing ? "ptr-spin 0.7s linear infinite" : "none",
          transform: refreshing ? "none" : `rotate(${pullDistance * 3}deg)`,
          opacity: Math.min(pullDistance / THRESHOLD, 1),
        }}
      />
      <style>{`@keyframes ptr-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default PullIndicator;
